/**
 *
 */

import { Injectable } from '@angular/core';
import { RequestOptions, URLSearchParams } from '@angular/http';

import { AppinfoService } from './appinfo.service';
import { CommonRequestService } from './common-request.service';
import { AppSettings } from '../app.settings';

export interface Application {
	name: string;
	desc: string;
	subPlan: SubscriptionPlanItem[];
	isPortalAccess: boolean;
	isSubscribed?: boolean;
}
export interface SubscriptionPlanItem {
	// item: string; // first property
	label: string;
	status: number;
	basic: string;
	professional: string;
	enterprise: string;
}

@Injectable()
export class SubscriptionManagementService {

	public apps: Application[];

	constructor(
		private appinfoService: AppinfoService,
		private requestService: CommonRequestService
	) {}
	getApps(successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'admin/appList';
		const params = new URLSearchParams();
		const options = new RequestOptions();
		params.set('portalAccess', 'true');
		options.params = params;
		return this.requestService.requestGet(url, options,
			(rsp) => {
				this.apps = this.transformApps(rsp.data);
				if (successCallback) {
					successCallback(this.apps);
				}
			}, (err) => {
				if (errorCallback) {
					errorCallback();
				}
			}, true);
	}
	transformApps(data): Application[] {
		const apps: Application[] = [];
		data.forEach((item) => {
			apps.push({
				name: item.mod_cd,
				desc: item.mod_desc,
				subPlan: null,
				isPortalAccess: item.mod_portal_access
			});
		});
		return apps;
	}
	getSubscriptionPlan(appName: string, successCallback?: (a: SubscriptionPlanItem[]) => any, errorCallback?): void {
		const url = AppSettings.serviceRootUrl + 'admin/subscriptionPlans';
		const params = new URLSearchParams();
		const options = new RequestOptions();
		params.set('application', appName);
		options.params = params;
		this.requestService.requestGet(url, options,
			(rsp) => {
				if (successCallback) {
					const plan = this.transformSubPlans(rsp);
					successCallback(plan);
				}
			}, (err) => {
				if (errorCallback) {
					errorCallback();
				}
			});
	}
	transformSubPlans(data): SubscriptionPlanItem[] {
		// const firstColProp = 'item';
		const dataRows = [];
		if (data.data) {
			data.data.forEach((d) => {
				// const firstColValue = Object.keys(d)[0];
				// const row = {};
				// // Update first property in row
				// row[firstColProp] = firstColValue;
				// // Update the rest property in row
				// Object.assign(row, d[firstColValue]);
				dataRows.push(d[Object.keys(d)[0]]);
			});
		}
		return dataRows;
	}

	getSubscriptionLevels() {
		let idx = 0;
		return [
			{
				name: 'Basic',
				value: 'BASIC',
				id: this.appinfoService.dict.subLevels.BASIC,
				idx: idx++
			},
			{
				name: 'Professional',
				value: 'PROFESSIONAL',
				id: this.appinfoService.dict.subLevels.PROFESSIONAL,
				idx: idx++
			}, {
				name: 'Enterprise',
				value: 'ENTERPRISE',
				id: this.appinfoService.dict.subLevels.ENTERPRISE,
				idx: idx++
			}
		];
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/subscription-management.service.ts